"use strict";

exports.__esModule = true;
exports.createAnswer = exports.createCallOffer = exports.updateCallRequest = undefined;

var _templateObject = _taggedTemplateLiteralLoose(["\n\n  mutation updateCallRequest(\n    $where: CallRequestWhereUniqueInput!\n    $data: CallRequestUpdateInput!\n  ){\n    updateCallRequest(\n      where:$where\n      data: $data\n    ){\n      ...callRequest\n    }\n  }\n\n  ", "\n\n"], ["\n\n  mutation updateCallRequest(\n    $where: CallRequestWhereUniqueInput!\n    $data: CallRequestUpdateInput!\n  ){\n    updateCallRequest(\n      where:$where\n      data: $data\n    ){\n      ...callRequest\n    }\n  }\n\n  ", "\n\n"]),
    _templateObject2 = _taggedTemplateLiteralLoose(["\n\n  mutation createCallOffer(\n    $id:ID!\n    $offer:Json!\n  ){\n    createOffer: createCallOffer(\n      id:$id\n      offer:$offer\n    ){\n      ...callRequest\n    }\n  }\n\n  ", "\n\n"], ["\n\n  mutation createCallOffer(\n    $id:ID!\n    $offer:Json!\n  ){\n    createOffer: createCallOffer(\n      id:$id\n      offer:$offer\n    ){\n      ...callRequest\n    }\n  }\n\n  ", "\n\n"]),
    _templateObject3 = _taggedTemplateLiteralLoose(["\n\n  mutation createAnswer(\n    $id:ID!\n    $answer:Json!\n  ){\n    createAnswer(\n      id:$id\n      answer:$answer\n    ){\n      ...callRequest\n    }\n  }\n\n  ", "\n\n"], ["\n\n  mutation createAnswer(\n    $id:ID!\n    $answer:Json!\n  ){\n    createAnswer(\n      id:$id\n      answer:$answer\n    ){\n      ...callRequest\n    }\n  }\n\n  ", "\n\n"]);

var _graphqlTag = require("graphql-tag");

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _index = require("./index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
} // export const signup = gql`
//   mutation signup(
//     $username:String!
//   ){
//     user:signup(
//       username:$username
//     ){
//       ...user
//     }
//   }
//   ${fragmentUser}
// `
// export const createCallRequest = gql`
//   mutation createCallRequest(
//     $callerId:ID!
//     $calledId:ID!
//     $offer:Json!
//     $sdp:Json!
//     $room: ID!
//   ){
//     createCallRequest(
//       # roomId:ID
//       callerId:$callerId
//       calledId:$calledId
//       offer: $offer
//       sdp: $sdp
//       room: $room
//     ){
//       ...callRequest
//     }
//   }
//   ${fragmentCallRequest}
// `;
// export const createCallRequest = gql`
//   mutation createCallRequest(
//     $calledId:ID!
//     # $offer:Json!
//     $callId: ID!
//   ){
//     createCallRequest(
//       data: {
//         # roomId:ID
//         calledId:$calledId
//         # offer: $offer
//         callId: $callId
//         caller_descriptions: {}
//         called_descriptions: {}
//       }
//     ){
//       ...callRequest
//     }
//   }
//   ${fragmentCallRequest}
// `;
// export const createCallRequestProcessor = gql`
//   mutation createCallRequestProcessor(
//     $calledId:ID!
//     $callId: ID!
//   ){
//     response: createCallRequestProcessor(
//       data: {
//         # roomId:ID
//         calledId:$calledId
//         # offer: $offer
//         callId: $callId
//         caller_descriptions: {}
//         called_descriptions: {}
//       }
//     ){
//       success
//       message
//       errors{
//         key
//         message
//       }
//       data{
//         ...callRequest
//       }
//     }
//   }
//   ${fragmentCallRequest}
// `;


var updateCallRequest = exports.updateCallRequest = (0, _graphqlTag2.default)(_templateObject, _index.fragmentCallRequest);
var createCallOffer = exports.createCallOffer = (0, _graphqlTag2.default)(_templateObject2, _index.fragmentCallRequest);
var createAnswer = exports.createAnswer = (0, _graphqlTag2.default)(_templateObject3, _index.fragmentCallRequest);